import { useNavigate } from 'react-router-dom';

export interface StationCardData {
  slug: string;
  displayName: string;
  icon?: string;
  description?: string;
}

interface StationGridProps {
  stations: StationCardData[];
  activeSlug: string | null;
}

/**
 * 2-column grid of industry stations. Clicks navigate via the
 * router — the route effect in RadioHomePage picks up the change
 * and asks radioStore to switch streams without a remount.
 */
export function StationGrid({ stations, activeSlug }: StationGridProps) {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 gap-2" data-testid="station-grid">
      {stations.map((station) => {
        const isActive = station.slug === activeSlug;
        return (
          <button
            key={station.slug}
            type="button"
            onClick={() => navigate(`/r/${station.slug}`)}
            className={`rounded-lg border p-3 text-left text-sm transition-colors ${
              isActive
                ? 'border-violet-400 bg-violet-500/15 text-white'
                : 'border-white/10 bg-white/5 text-white/80 hover:border-white/30'
            }`}
          >
            <div className="text-base">{station.icon ?? '🎵'}</div>
            <div className="mt-1 font-semibold">{station.displayName}</div>
            {station.description ? (
              <div className="mt-0.5 line-clamp-2 text-[11px] text-white/50">
                {station.description}
              </div>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
